import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Register from "../views/Register.vue";
import QuickSubmit from "../views/QuickSubmit.vue";
import History from "../views/History.vue";
import Status from "../views/Status.vue";
import StatusDetail from "../views/StatusDetail.vue";
import Member from "../views/Member.vue";
import About from "../views/About.vue";
import Profile from "../views/Profile.vue";
import EditProfile from "../views/EditProfile.vue";
import EmailAuthTutorial from "../views/EmailAuthTutorial.vue";
import AddressBook from "../views/AddressBook.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/hot",
    name: "HotRank",
    component: Home,
  },
  {
    path: "/quick-submit",
    name: "QuickSubmit",
    component: QuickSubmit,
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "/status",
    name: "Status",
    component: Status,
  },
  {
    path: "/status/detail",
    name: "StatusDetail",
    component: StatusDetail,
  },
  {
    path: "/member",
    name: "Member",
    component: Member,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/profile/edit",
    name: "EditProfile",
    component: EditProfile,
  },
  {
    path: "/email-auth-tutorial",
    name: "EmailAuthTutorial",
    component: EmailAuthTutorial,
  },
  {
    path: "/address-book",
    name: "AddressBook",
    component: AddressBook,
  },
  {
    path: "*",
    redirect: "/login",
  },
];

const router = new VueRouter({
  mode: "hash",
  // hash 模式下 base 配置影响较小，但为了保持一致，使用空字符串或 undefined
  base:
    process.env.NODE_ENV === "production" ? "/" : process.env.BASE_URL || "/",
  routes,
});

export default router;
